<template>
  <div class="menu-detail">
    <el-card class="detail-card">
      <div class="detail-header">
        <h2>{{ menuName }}</h2>
      </div>
      <div class="detail-content" v-loading="loading">
        <div v-if="content" v-html="content"></div>
        <el-empty v-else description="暂无内容" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'MenuDetail',
  data() {
    return {
      loading: false,
      content: '',
      menuName: ''
    }
  },
  computed: {
    menuId() {
      return this.$route.params.id
    }
  },
  async created() {
    await this.fetchMenuDetail()
  },
  methods: {
    async fetchMenuDetail() {
      this.loading = true
      try {
        const menuList = this.$store.state.menuList
        const currentMenu = menuList.find(item => item.id === parseInt(this.menuId))
        
        if (currentMenu) {
          this.menuName = currentMenu.menuName
          this.content = this.getMockContent(currentMenu.menuName)
          
          // 设置页面标题
          this.setPageTitle(currentMenu.menuName)
        }
      } catch (error) {
        console.error('获取菜单详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    setPageTitle(detailTitle) {
      const siteTitle = this.$store.state.siteConfig.showTitle || '辽宁资产管理有限公司'
      document.title = `${detailTitle} - ${siteTitle}`
    },
    getMockContent(menuName) {
      const contentMap = {
        '公司概况': '<p>这里是公司概况的详细内容...</p>',
        '公司简介': '<p>这里是公司简介的详细内容...</p>',
        '党建概况': '<p>这里是党建概况的详细内容...</p>',
        '企业文化': '<p>这里是企业文化的详细内容...</p>',
        '通知公告': '<p>这里是通知公告的详细内容...</p>',
        '廉洁资管': '<p>这里是廉洁资管的详细内容...</p>',
        '组织架构': '<p>这里是组织架构的详细内容...</p>',
        '资讯中心': '<p>这里是资讯中心的详细内容...</p>',
        '党建动态': '<p>这里是党建动态的详细内容...</p>',
        '联系我们': '<p>这里是联系我们的详细内容...</p>',
        '党章党规': '<p>这里是党章党规的详细内容...</p>',
        '企业党建': '<p>这里是企业党建的详细内容...</p>',
        '招贤纳士': '<p>这里是招贤纳士的详细内容...</p>',
        '业务介绍': '<p>这里是业务介绍的详细内容...</p>',
        '推介信息': '<p>这里是推介信息的详细内容...</p>',
        '处置公告': '<p>这里是处置公告的详细内容...</p>',
        '在拍资产': '<p>这里是在拍资产的详细内容...</p>',
        '招标采购': '<p>这里是招标采购的详细内容...</p>',
        '公司新闻': '<p>这里是公司新闻的详细内容...</p>'
      }
      return contentMap[menuName] || `<p>${menuName}的内容...</p>`
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-detail {
  .detail-card {
    max-width: 1200px;
    margin: 0 auto;
    
    .detail-header {
      padding-bottom: 20px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 20px;
      
      h2 {
        color: #303133;
        font-size: 28px;
        font-weight: 600;
      }
    }
    
    .detail-content {
      min-height: 400px;
      line-height: 1.8;
      color: #606266;
    }
  }
}
</style>
